import type {Me} from "@/src/modules/core/types";

export function meRequiresPlaceholderProfileCompletion(me: Me | null | undefined): boolean {
  return Boolean(me?.isResident && me.is_placeholder);
}
